import styled from "styled-components";

export const RootContainer = styled.div`
	padding: 0 16px;
`;

export const Title = styled.div`
padding: 6px 12px;
margin: 16px 0 14px 0;
border-radius: 8px;
background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
backdrop-filter: blur(25px);

	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	color: #1E1E1E;
	text-align: center;
`;

export const Item = styled.div`
	display: flex;
	flex-direction: column;
	grid-gap: 8px;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	@media screen and (max-width: 325px) {
		grid-gap: 6px;
		padding: 6px 0px;
	}
`;

export const Text = styled.div`
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #2A2A2A;
	text-align: center;
`;

export const Image = styled.img.attrs({
	alt: "img",
})`
	width: 100%;
	max-width: 78px;
	border-radius: 8px;
	aspect-ratio: 1;
	object-fit: contain;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

	@media screen and (max-width: 325px) {
		max-width: 65px;
	}
`;

export const SpinWrapper = styled.div`
	height: calc(100vh - 70px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const LightText = styled.div`
margin: 16px 0 20px 0;
font-size: 14px;
font-weight: 400;
color: #2A2A2A;
line-height: 1.5;
`;